import React from 'react';
import './notFoundPage.css';

function NotFoundPage() {
  return (<div className="notFound-container">404</div>)
}

export default NotFoundPage;